import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// PrivacyLeafletAcceptTrigger

export const PRIVACY_LEAFLET_ACCEPT_TRIGGER = 'PRIVACY_LEAFLET_ACCEPT_TRIGGER';
export interface PrivacyLeafletAcceptTriggerAction {
    readonly type: typeof PRIVACY_LEAFLET_ACCEPT_TRIGGER;
}
export const PRIVACY_LEAFLET_ACCEPT_REQUEST = 'PRIVACY_LEAFLET_ACCEPT_REQUEST';
export interface PrivacyLeafletAcceptRequestAction extends APIRequestAction {
    readonly type: typeof PRIVACY_LEAFLET_ACCEPT_REQUEST;
}
export interface PrivacyLeafletAcceptNormalizedResponse extends NormalizedResponse {
    readonly result: { };
}
export const PRIVACY_LEAFLET_ACCEPT_SUCCESS = 'PRIVACY_LEAFLET_ACCEPT_SUCCESS';
export interface PrivacyLeafletAcceptSuccessAction extends APISuccessAction<PrivacyLeafletAcceptNormalizedResponse> {
    readonly type: typeof PRIVACY_LEAFLET_ACCEPT_SUCCESS;
}
export const PRIVACY_LEAFLET_ACCEPT_FAILURE = 'PRIVACY_LEAFLET_ACCEPT_FAILURE';
export interface PrivacyLeafletAcceptFailureAction extends APIFailureAction {
    readonly type: typeof PRIVACY_LEAFLET_ACCEPT_FAILURE;
}

export const privacyLeafletAcceptTrigger =
    (): PrivacyLeafletAcceptTriggerAction => ({
        type: PRIVACY_LEAFLET_ACCEPT_TRIGGER,
    });
export const privacyLeafletAcceptApi = {
    request: (): PrivacyLeafletAcceptRequestAction => ({
        type: PRIVACY_LEAFLET_ACCEPT_REQUEST,
    }),
    success: (response: PrivacyLeafletAcceptNormalizedResponse): PrivacyLeafletAcceptSuccessAction => ({
        type: PRIVACY_LEAFLET_ACCEPT_SUCCESS, response,
    }),
    failure: (error: any): PrivacyLeafletAcceptFailureAction => ({
        type: PRIVACY_LEAFLET_ACCEPT_FAILURE, error,
    }),
};
